import { useCallback, useEffect, useState } from "react";
import CommonPrefetchedData from "src/components/ShareMenu/helpers/PrefetchedData/CommonPrefetchedData";
import log from "src/helpers/log";
import toast from "src/swsh-native/toast";

const useWebImageDownload = (data: CommonPrefetchedData[]) => {
	const [loading, setLoading] = useState(true);

	const handleDownloadImages = useCallback(async () => {
		if (!navigator || typeof navigator.share !== "function") {
			return {
				didComplete: false,
				didError: true,
			};
		}
		return await navigator
			.share({
				files: await Promise.all(
					data.map(async (prefetchedData, i) => {
						const [blob, { ext, contentType }] = await Promise.all([
							prefetchedData.blob(),
							prefetchedData.metadata(),
						]);
						return new File([blob], `${i}.${ext}`, {
							type: contentType,
						});
					}),
				),
			})
			.then(() => {
				return {
					didComplete: true,
					didError: false,
				};
			})
			.catch((err) => {
				if (err.name === "AbortError") {
					return {
						didComplete: false,
						didError: false,
					};
				}
				log.error({ err }, "Error downloading data");
				toast({
					preset: "error",
					title: "Error downloading data",
				});
				return {
					didComplete: false,
					didError: true,
				};
			});
	}, [data]);

	useEffect(() => {
		(async () => {
			setLoading(true);
			try {
				await Promise.all(data.map(({ blob }) => blob()));
			} catch (err) {
				log.error({ err }, "Error downloading data");
				toast({
					preset: "error",
					title: "Error downloading data",
				});
			}
			setLoading(false);
		})();
	}, [data]);

	return {
		loading,
		handleDownloadImages,
	};
};
export default useWebImageDownload;
